'use client';

import { startTransition } from 'react';
import { useShallow } from 'zustand/shallow';
import { usePageAction } from '@repo/hooks/usePageAction';
import { APY_INPUT_PATTERN } from '../../constants';
import { ApyPercentCalculatorInput } from '../../shared/ApyPercentCalculatorInput';
import { formatToDisplayValue, isAmbiguousAnnualApyString } from '../../utils/calculatorFormMath';
import { handleAnnualApyInput } from './annualApyInput';
import { useCdCalculatorStore } from './calculatorStore';

export function AnnualPercentYieldForm() {
  const fireCdCalculatorInteractedPageAction = usePageAction({
    actionName: 'cd_calculator_interacted',
    actionSection: 'banking',
    actionType: 'select',
  });
  const {
    annualPercentageYield,
    annualPercentageYieldError,
    initialDeposit,
    setField,
    termLength,
    termLengthUnit,
  } = useCdCalculatorStore(
    useShallow(state => ({
      annualPercentageYield: state.formFields.annualPercentageYield,
      annualPercentageYieldError: state.errors.annualPercentageYield,
      initialDeposit: state.formFields.initialDeposit.includes(',')
        ? state.formFields.initialDeposit.replace(/,/g, '')
        : formatToDisplayValue(state.formFields.initialDeposit),
      setField: state.setField,
      termLength: state.formFields.termLength,
      termLengthUnit: state.formFields.termLengthUnit,
    })),
  );

  return (
    <ApyPercentCalculatorInput
      error={annualPercentageYieldError}
      id="annual-percentage-yield"
      value={annualPercentageYield}
      onChange={e => {
        handleAnnualApyInput(e.target.value, {
          fireCdCalculatorInteractedPageAction,
          initialDeposit,
          termLength,
          termLengthUnit,
          setField,
          startTransition,
        });
      }}
      onBlur={e => {
        const target = e.target.value;
        if (!APY_INPUT_PATTERN.test(target)) {
          return;
        }
        if (isAmbiguousAnnualApyString(target)) {
          handleAnnualApyInput(target.replace('.', ''), {
            fireCdCalculatorInteractedPageAction,
            initialDeposit,
            termLength,
            termLengthUnit,
            setField,
            startTransition,
          });
        }
      }}
    />
  );
}
